import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_right_s",
  "use": "chevron_right_s-usage",
  "viewBox": "0 0 5 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5 6\" id=\"chevron_right_s\"><path d=\"M1 6c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L1.6 3 .3 1.7C-.1 1.3-.1.7.3.3s1-.4 1.4 0L4.4 3 1.7 5.7c-.2.2-.4.3-.7.3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol